<template>
  <div class="goods-items">
    <div class="goods-items-content">
      <div class="item-img">
        <div @click="goDetail(item)">
          <img :src="item.cover" alt class="goods-pic" />
          <span class="order-status-babel" v-if="isShowProductStatusLabel && item.status">{{
            item.status
          }}</span>
        </div>
      </div>
      <div class="goods-right">
        <div class="goods-info">
          <div @click="goDetail(item)" class="goods-name">
            {{ item.name }}
          </div>
          <div class="goods-size">
            <div style="margin-right: 30px">颜色：{{ item.color.name }}</div>
            <div>尺码：{{ item.size }}</div>
          </div>
          <ProductLabel
            v-if="isShowProductLabel"
            :product-label="item.product_label"
          />
        </div>
        <div class="goods-others">
          <div class="goods-price">
            <div class="num">x{{ item.quantity }}</div>
            <div class="price">
              <p class="item-original_price" v-if="isShowOriginalPrice(item)">
                <span class="rmb-symbol">￥</span
                >{{ (item.original_price || 0) | filterPrice }}
              </p>
              <p><span class="rmb-symbol">￥</span>{{ item.price }}</p>
            </div>
          </div>
          <div class="payment-detail is-desktop" v-if="isNeedPaymentDetail">
            <div class="point-text">
              实付金额：<span>￥{{ item.row_amount || item.price }}</span>
            </div>
            <div class="point-text">
              使用积分：<span>{{ item.pointsDeducted }}积分</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="payment-detail is-mobile" v-if="isNeedPaymentDetail">
      <!-- TODO: 联调替换取值 -->
      <div class="point-text">
        实付金额：<span>￥{{ item.row_amount || item.price }}</span>
      </div>
      <div class="point-text">
        使用积分：<span>{{ item.pointsDeducted }}积分</span>
      </div>
    </div>
  </div>
</template>

<script>
import ProductLabel from "@/components/ProductLabel.vue";
import utils from "@/utils";
// 从订单详情中复制出一份orderItem，用到的地方比较多
export default {
  name: "OrderItem",
  components: { ProductLabel },
  props: {
    item: {
      type: Object,
      required: true,
    },
    orderStatus: {
      type: String,
      default: "",
    },
    isShowProductStatusLabel: {
      type: Boolean,
      default: true,
    },
    isShowProductLabel: {
      type: Boolean,
      default: true,
    },
    isNeedPaymentDetail: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    isShowOriginalPrice: utils.isShowOriginalPrice,
    goDetail(item) {
      if (!item?.goodsId || !item?.color?.id) {
        return;
      }
      if (Number(item.skc_status) === 0) {
        //skc下架
        return;
      }
      this.$router.push({ path: `/detail/${item.goodsId}-${item.color.id}` });
    },
  },
  computed: {
    isMobile() {
      return utils.isMobile() || utils.isWXBrowser();
    },
  },
};
</script>

<style lang="scss" scoped>
.goods-items {
  & + .goods-items {
    margin-top: 24px;
  }

  .markdown-tip {
    display: flex;
    align-items: center;
    color: #212322;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    margin-top: 8px;

    .iconfont-ot-website {
      margin-right: 2px;
      cursor: pointer;
    }

    &.is-desktop {
      display: none;
    }

    &.is-mobile {
      display: block;
    }
  }
}

.goods-items-content {
  display: flex;
  box-sizing: border-box;
  padding: 0;

  .item-img {
    width: 86px;
    height: 86px;
    border-radius: 1px;
    border: 1px solid #dfdfdf;
    margin-right: 8px;
    flex-shrink: 0;
    box-sizing: border-box;
    padding: 2px;
    position: relative;

    .goods-pic {
      // width: 78px;
      width: 100%;
      height: auto;
    }

    .order-status-babel {
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      font-size: 12px;
      text-align: center;
      line-height: 18px;
    }
  }

  .goods-right {
    display: flex;
    flex-direction: column;
  }

  .goods-info {
    display: flex;
    flex-direction: column;
    width: 100%;

    .goods-size {
      display: flex;
      color: #999999;
      font-size: 12px;
      margin-top: 4px;
    }

    .goods-name {
      font-size: 14px;
      color: #333;
    }
  }

  .goods-others {
    display: flex;
    flex-direction: column;
    font-size: 12px;
    color: #000;
    margin-top: 10px;
    width: 100%;

    .goods-price {
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
      align-items: flex-end;
      gap: 10px;
    }

    .item-original_price {
      font-weight: 400;
      color: #999;
      text-decoration: line-through;
    }
  }
}
@media only screen and (max-width: 767px) {
  .payment-detail {
    display: flex;
    flex-direction: row;
    padding: 8px 0px;
    justify-content: space-between;
    align-content: center;
    background: #f8f8f8;

    .point-text {
      color: #999;
      flex: 1;
      padding: 0;
      text-align: center;
      span {
        color: #333;
      }
      &:first-child {
        position: relative;
        padding: 0;
        &::after {
          content: "";
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 1px;
          height: 12px;
          background-color: #bcbdbf;
        }
      }
    }
    &.is-desktop {
      display: none;
    }
    &.is-mobile {
      display: flex;
    }
  }
}

@media only screen and (min-width: 768px) {
  .goods-others {
  }
  .payment-detail {
    display: flex;
    flex-direction: row;
    align-content: center;

    .point-text {
      padding: 0px 20px;
      color: #999;
      span {
        color: #333;
      }
      &:first-child {
        position: relative;
        padding-left: 0px;
        &::after {
          content: "";
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 1px;
          height: 12px;
          background-color: #bcbdbf;
        }
      }
    }

    &.is-mobile {
      display: none;
    }
  }
}
@media only screen and (min-width: 1025px) {
  .goods-items {
    .markdown-tip {
      display: flex;
      align-items: center;
      color: #212322;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      margin-top: 6px;

      .iconfont-ot-website {
        margin-right: 2px;
      }

      &.is-desktop {
        display: block;
      }

      &.is-mobile {
        display: none;
      }
    }
  }

  .goods-items-content {
    display: flex;
    box-sizing: border-box;
    // margin-bottom: 20px;
    // padding: 0 30px;

    .item-img {
      width: 70px;
      height: 70px;
      border-radius: 1px;
      border: 1px solid #dfdfdf;
      margin-right: 20px;
      flex-shrink: 0;
      box-sizing: border-box;
      padding: 2px;

      .goods-pic {
        width: 64px;
        height: 64px;
      }
    }

    .goods-right {
      display: flex;
      flex-direction: row;
      flex-grow: 1;
      justify-content: space-between;

      .goods-info {
        display: flex;
        flex-direction: column;
        width: 60%;

        .goods-size {
          display: flex;
          color: #999999;
          font-size: 14px;
        }

        .goods-name {
          font-size: 14px;
          color: #333;
        }
      }

      .goods-others {
        width: 25%;
        align-self: flex-start;
        margin-top: 0;
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
}
</style>
